import { handleRequest } from '@/lib/api/factories/base-api-factory';
import bookingInstance from '@/lib/axios/booking-instance';
import type { IBaseResponse } from '@/types/base-response';

/**
 * GET /feature-flags/me — every release flag for the company in scope, as
 * `key → on`. The booking instance attaches the company picked in the
 * switcher, so a super Admin gets the flags of the tenant they are viewing.
 */
const getMyFlags = (): Promise<IBaseResponse<Record<string, boolean>>> =>
  handleRequest(bookingInstance.get('/feature-flags/me'));

export const FeatureFlagService = { getMyFlags };
